import React, { useState } from 'react';
import { Outlet } from "react-router-dom";
import Header from './components/Header';
import Footer from './components/Footer';
import './css/Common.css'
import './css/floatingButtons.css'

const IcoWhatsApp = () => (
  <svg width="30" height="30" viewBox="0 0 24 24" fill="currentColor">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.149-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
  </svg>
);

const IcoSend = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="22" y1="2" x2="11" y2="13"/>
    <polygon points="22 2 15 22 11 13 2 9 22 2"/>
  </svg>
);

/* Friendly "Uncle" avatar -- fills the full circle */
const UncleAvatar = ({ size = 48 }) => (
  <svg width={size} height={size} viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <clipPath id="uncleClip"><circle cx="50" cy="50" r="50" /></clipPath>
      <linearGradient id="uncleBg" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stopColor="#6dd05a" />
        <stop offset="100%" stopColor="#3d7a30" />
      </linearGradient>
    </defs>
    <g clipPath="url(#uncleClip)">
      {/* green background */}
      <rect width="100" height="100" fill="url(#uncleBg)" />
      {/* shoulders / shirt */}
      <ellipse cx="50" cy="104" rx="34" ry="26" fill="#1C2634" />
      <path d="M34 90 L50 100 L66 90 Z" fill="#fff" opacity="0.9" />
      {/* neck */}
      <rect x="43" y="64" width="14" height="14" rx="6" fill="#e8b48c" />
      {/* head */}
      <circle cx="50" cy="48" r="22" fill="#f3c39e" />
      {/* ears */}
      <circle cx="28" cy="49" r="4.5" fill="#f3c39e" />
      <circle cx="72" cy="49" r="4.5" fill="#f3c39e" />
      {/* grey hair sides + top */}
      <path d="M28 44 Q30 24 50 24 Q70 24 72 44 Q72 36 64 33 Q58 28 50 28 Q42 28 36 33 Q28 36 28 44 Z" fill="#d9dde0" />
      {/* eyebrows (grey) */}
      <rect x="37" y="42" width="9" height="2.6" rx="1.3" fill="#b8bcc0" />
      <rect x="54" y="42" width="9" height="2.6" rx="1.3" fill="#b8bcc0" />
      {/* glasses */}
      <circle cx="41.5" cy="48" r="6.5" fill="none" stroke="#1C2634" strokeWidth="2" />
      <circle cx="58.5" cy="48" r="6.5" fill="none" stroke="#1C2634" strokeWidth="2" />
      <line x1="48" y1="48" x2="52" y2="48" stroke="#1C2634" strokeWidth="2" />
      {/* eyes */}
      <circle cx="41.5" cy="48" r="2" fill="#1C2634" />
      <circle cx="58.5" cy="48" r="2" fill="#1C2634" />
      {/* nose */}
      <path d="M50 52 L48 58 Q50 60 52 58 Z" fill="#e0a87f" />
      {/* grey mustache */}
      <path d="M40 62 Q50 66 60 62 Q56 60 50 61 Q44 60 40 62 Z" fill="#d9dde0" />
      {/* smile */}
      <path d="M43 64 Q50 69 57 64" stroke="#b07a5a" strokeWidth="1.6" fill="none" strokeLinecap="round" />
    </g>
  </svg>
);

const QUICK_REPLIES = [
  'How to apply for a loan?',
  'Check my eligibility',
  'Calculate EMI',
  'What documents do I need?',
  'Interest rates?',
];

const BOT_GREETING = `Namaste! I'm **Uncle**, your Salary Uncle AI assistant.\n\nI can help you with loans, eligibility, EMI calculations, and more. Kya main aapki madad kar sakta hoon?`;

function now() {
  const d = new Date();
  return d.toLocaleTimeString('en-IN', { hour: '2-digit', minute: '2-digit', hour12: true });
}

function Layout() {
  const [chatOpen, setChatOpen] = useState(false);
  const [messages, setMessages] = useState([
    { from: 'bot', text: BOT_GREETING, time: now() }
  ]);
  const [input, setInput] = useState('');

  const send = (text) => {
    const msg = text || input.trim();
    if (!msg) return;
    setMessages(m => [...m, { from: 'user', text: msg, time: now() }]);
    setInput('');
    setTimeout(() => {
      setMessages(m => [...m, {
        from: 'bot',
        text: 'Thank you for your message! Our team will get back to you shortly. For immediate help, call us at +91 93557 53533.',
        time: now()
      }]);
    }, 800);
  };

  return (
    <div className="wrapper">
      <div id="snackbar"></div>
      <Header />
      <main className="">
        <Outlet />
      </main>

      <footer className="">
        <Footer />
      </footer>

      {/* ── AI Chatbot -- bottom LEFT ── */}
      {!chatOpen && (
        <button className="fab-chatbot-pill" onClick={() => setChatOpen(true)} aria-label="Open AI Chat">
          <div className="fab-pill-avatar">
            <UncleAvatar size={48} />
            <span className="fab-pill-badge">1</span>
          </div>
          <span className="fab-pill-text">Hi, I am Uncle</span>
        </button>
      )}

      {/* ── Chat Panel ── */}
      {chatOpen && (
        <div className="myra-panel">
          {/* HEADER */}
          <div className="myra-header">
            <div className="myra-header-avatar">
              <UncleAvatar size={42} />
              <span className="myra-online-dot"></span>
            </div>
            <div className="myra-header-info">
              <div className="myra-header-name">Uncle</div>
              <div className="myra-header-status">
                <span className="myra-status-dot"></span> Online · AI Assistant
              </div>
            </div>
            <button className="myra-close" onClick={() => setChatOpen(false)} aria-label="Close chat">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
            </button>
          </div>

          {/* Messages */}
          <div className="myra-body">
            {messages.map((m, i) => (
              <div key={i} className={`myra-row myra-row--${m.from}`}>
                {m.from === 'bot' && (
                  <div className="myra-avatar-sm">
                    <UncleAvatar size={32} />
                  </div>
                )}
                <div className="myra-bubble-wrap">
                  <div className={`myra-bubble myra-bubble--${m.from}`}>
                    {m.text.split('**').map((part, j) =>
                      j % 2 === 1 ? <strong key={j}>{part}</strong> : part
                    )}
                  </div>
                  <div className="myra-time">{m.time}</div>
                </div>
              </div>
            ))}

            {/* Quick reply chips */}
            {messages.length === 1 && (
              <div className="myra-chips">
                {QUICK_REPLIES.map((q) => (
                  <button key={q} className="myra-chip" onClick={() => send(q)}>{q}</button>
                ))}
              </div>
            )}
          </div>

          {/* Input */}
          <div className="myra-footer">
            <input
              className="myra-input"
              type="text"
              placeholder="Ask Uncle anything..."
              value={input}
              onChange={e => setInput(e.target.value)}
              onKeyDown={e => e.key === 'Enter' && send()}
            />
            <button className="myra-send" onClick={() => send()} aria-label="Send">
              <IcoSend />
            </button>
          </div>
          <div className="myra-powered">Powered by Salary Uncle AI</div>
        </div>
      )}

      {/* ── WhatsApp -- bottom RIGHT ── */}
      <a
        href="https://wa.me/917428966114"
        className="fab-whatsapp"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat on WhatsApp"
      >
        <IcoWhatsApp />
      </a>
    </div>
  );
}

export default Layout;
